import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-3">
              <span className="text-lg font-heading font-bold text-foreground-900">挠脚心<span className="text-primary-500">vk</span></span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">探索挠脚心vk的全方位内容聚合平台，汇聚视频、社区、文章与话题讨论。</p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">内容导航</h4>
            <div className="flex flex-col gap-2">
              {navLinks.slice(1, 5).map((link) => (
                <Link key={link.path} to={link.path} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">热门标签</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/shipin" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">挠脚心vk视频</Link>
              <Link to="/category/shequ" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">挠脚心社区</Link>
              <Link to="/category/huati" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">挠脚心话题</Link>
              <Link to="/category/ziyuan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">资源合集</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">品牌介绍</Link>
              <a href="mailto:contact@naojiaoxinvk.com" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">联系我们</a>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">&copy; 2025 挠脚心vk 内容聚合平台. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信"><i className="ri-wechat-line text-lg"></i></a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博"><i className="ri-weibo-line text-lg"></i></a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="QQ"><i className="ri-qq-line text-lg"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}